import { useCallback, useState } from 'react';

/**
 * 日本語入力の変換状態を管理するカスタムフック
 */
export const useComposition = () => {
  const [isComposing, setIsComposing] = useState(false);

  const onCompositionStart = useCallback(() => {
    setIsComposing(true);
  }, []);

  const onCompositionEnd = useCallback(() => {
    setIsComposing(false);
  }, []);

  return {
    isComposing,
    onCompositionStart,
    onCompositionEnd,
  };
};
